module.exports = __webpack_public_path__ + "img/sofacompany.4c6c421d.png";